import { CandidateItem } from 'api-types';
import { Typography } from '@mui/joy';
import styles from '../../candidate.module.css';
import { LinkedInLogo } from '../../../../components/Logo/LinkedinLogo';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneIcon from '@mui/icons-material/Phone';

export function CandidateHeaderDetails({ candidate }: { candidate: CandidateItem }) {
  return (
    <div className={styles.section}>
      <div className={styles.profileName}>
        <div>
          <Typography
            level="title-md"
            fontWeight={'lg'}
            gutterBottom
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            {`${candidate.firstName} ${candidate.lastName || ''}`}
            {candidate?.linkedinUrl && <LinkedInLogo url={candidate?.linkedinUrl} />}
          </Typography>

          <div className={styles.cardHeading}>
            <Typography level="body-sm" gutterBottom>
              {candidate.experiences?.[0]?.position}
            </Typography>
            <Typography level="body-sm" gutterBottom>
              {candidate.city}, {candidate.state}
            </Typography>
          </div>
        </div>
        <div>
          {candidate.email && (
            <Typography
              level="body-sm"
              gutterBottom
              startDecorator={<MailOutlineIcon fontSize="small" />}
            >
              {candidate.email}
            </Typography>
          )}
          {candidate.phoneNumber && (
            <Typography
              level="body-sm"
              gutterBottom
              startDecorator={<PhoneIcon fontSize="small" />}
            >
              {candidate.phoneNumber}
            </Typography>
          )}
        </div>
      </div>
    </div>
  );
}
